// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"n0-z","sponsoredTooltipWrapper":"o0-z","sponsoredTooltip":"p0-z","newCard":"q0-z"};